<template>
  <div class="error-container">
    <h3>
      <i class="el-icon-document-delete error-icon"></i>
      <br>
      요청하신 페이지가 존재하지 않습니다
    </h3>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>
.error-container {
  position: absolute;
  top: 0; bottom: 0; left: 0; right: 0;
  text-align: center;
  
  h3 {
    position: absolute;
    top: 35%; left: 0; right: 0;
    color: #adadad;
    font-weight: normal;
  }
  
  .error-icon {
    font-size: 80px;
    color: #bdbdbd;
    padding: 15px;
  }
}
</style>


